import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import common_de from "./translations/de/common.json";
import common_en from "./translations/en/common.json";
import common_fr from "./translations/fr/common.json";
import common_it from "./translations/it/common.json";

const resources = {
  de: {
    common: common_de,
  },
  en: {
    common: common_en,
  },
  fr: {
    common: common_fr, // 'common' is our custom namespace
  },
  it: {
    common: common_it,
  },
};

i18next.use(LanguageDetector).init({
  resources,
  lng: "de",
  debug: process.env.NODE_ENV === "development",
  supportedLngs: ["de", "en", "fr", "it"],
  fallbackLng: "de",
  interpolation: { escapeValue: false }, // React already does escaping
});

export default i18next;
